/** Um único pulso mantém o badge do shell coerente com atos feitos na Inbox. */
export const EVENTO_DE_NOTIFICACOES = 'dv:notificacoes-alteradas'

export function notificarBadge(naoLidas?: number): void {
  window.dispatchEvent(new CustomEvent(EVENTO_DE_NOTIFICACOES, { detail: naoLidas }))
}
